module.exports = __webpack_public_path__ + "static/img/system-5.7b747f54.png";